import { c as _c } from "react/compiler-runtime";
import { getSeatOptions } from "@components/table/members/assign-seats/assign-seats-utils";
import { useSeatsAvailable } from "@components/table/members/assign-seats/use-seats-available";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useMemberSeatsLookup } from "@hooks/use-member-seats-lookup";
import { xgSeatHoldersCountSelector } from "@store/members/members-selector";
import { activeSeatUsageSelector, canAssignManagersSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { getHeldSeats } from "@utils/member-seats-utils";
/**
 * Returns how to look up the seats a member holds and the ones the current user could change, for
 * a list of members such as the options of a menu that is shared by all the rows of a table.
 */
export function useGetMemberSeats() {
  const $ = _c(8);
  const memberSeatsLookup = useMemberSeatsLookup();
  const {
    canManageXgSeats,
    canManageSceneLicenses
  } = useHasUserValidRoleCompanyLevel();
  const seatsAvailable = useSeatsAvailable();
  const xgSeatsUsed = useAppSelector(activeSeatUsageSelector)?.used ?? 0;
  const canAssignManagers = useAppSelector(canAssignManagersSelector);
  const storedXgSeatHoldersCount = useAppSelector(xgSeatHoldersCountSelector);
  const xgSeatHoldersCount = canAssignManagers ? undefined : storedXgSeatHoldersCount;
  let t0;
  if ($[0] !== canManageSceneLicenses || $[1] !== canManageXgSeats || $[2] !== memberSeatsLookup || $[3] !== seatsAvailable.sceneSeat || $[4] !== seatsAvailable.xgSeat || $[5] !== xgSeatHoldersCount || $[6] !== xgSeatsUsed) {
    t0 = member => {
      const heldSeats = getHeldSeats(member, memberSeatsLookup);
      return {
        heldSeats,
        seatOptions: getSeatOptions({
          member,
          heldSeats,
          isActiveSeatPlan: memberSeatsLookup.isActiveSeatPlan,
          isUserRolePlan: memberSeatsLookup.isUserRolePlan,
          areSceneLicensesAvailable: memberSeatsLookup.hasSceneSeats,
          canManageXgSeats,
          canManageSceneLicenses,
          sceneSeatsAvailable: seatsAvailable.sceneSeat,
          xgSeatsAvailable: seatsAvailable.xgSeat,
          xgSeatsUsed,
          xgSeatHoldersCount
        })
      };
    };
    $[0] = canManageSceneLicenses;
    $[1] = canManageXgSeats;
    $[2] = memberSeatsLookup;
    $[3] = seatsAvailable.sceneSeat;
    $[4] = seatsAvailable.xgSeat;
    $[5] = xgSeatHoldersCount;
    $[6] = xgSeatsUsed;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}

/** Returns the seats a member holds and the ones the current user could change */
export function useMemberSeats(member) {
  const $ = _c(3);
  const t0 = useGetMemberSeats();
  let t1;
  if ($[0] !== member || $[1] !== t0) {
    t1 = t0(member);
    $[0] = member;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}